// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2MkjR","messages":"Chat_messages__2fuJT","dateDivider":"Chat_dateDivider__34YNa"};